import { Err, IConversation, IEvent, IPlace, ISentiment, IUser, Result, UserIntentions } from '@/classes'

export const sentimentGetAPI = async () => {
	const response: Result<{
		items: ISentiment[]
	}> = await fetchAPI('sentiments', { type: 'saved' })

	return response
}

export const sentimentCreateAPI = async (
  type: 'saved' | 'skipped' | 'blocked' | 'visit',
  params: {
    eventId?: string
    groupId?: string
    placeId?: string
		userIds?: string[]
		postIds?: string[]
		action?: 'create' | 'delete'
  }
) => {
	const response: Result<{
		place: IPlace | null
		event: IEvent | null
		success: boolean
	}> = await fetchAPI('sentiments/create', { type, ...params }, { method: 'POST' })

	return response
}

export const sentimentFollowAPI = async (
	userId: string,
	action: 'follow' | 'unfollow'
) => {
	const response: Result<{
		user: IUser
		following: string[]
		followers: string[]
	}> = await fetchAPI('sentiments/follow', { userId, action }, { method: 'POST' })

	return response
}

export const sentimentsFollowOrganizationAPI = async (
	organizationId: string,
	action: 'follow' | 'unfollow'
) => {
	const response: Result<{
		following: string[]
	}> = await fetchAPI('sentiments/follow/organization', { organizationId, action }, { method: 'POST' })

	return response
}

export const sentimentsFollowPlaceAPI = async (
	placeId: string,
	action: 'follow' | 'unfollow'
) => {
	const response: Result<{
		following: string[]
		followerCount: number
	}> = await fetchAPI('sentiments/follow/place', { placeId, action }, { method: 'POST' })

	return response
}

export const sentimentIntentionsAPI = async (
	userId: string,
	intentions: (typeof UserIntentions[number])[]
) => {
	const response: Result<{
		user: IUser
		conversation: IConversation | null
		match: typeof UserIntentions[number][]
	}> = await fetchAPI('sentiments/intentions', { userId, intentions }, { method: 'POST' })

	return response
}

export const sentimentSkipAPI = async (
  params: {
    eventIds?: string[]
    groupIds?: string[]
    placeIds?: string[]
		userIds?: string[]
		postIds?: string[]
  }
) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('sentiments/skip', params, { method: 'POST' })

	return response
}